export const FETCH_CPVALUE_INIT_ACTION = 'FETCH_CPVALUE_INIT_ACTION';
export const FETCH_CPVALUE_SUCCESS_ACTION =
  FETCH_CPVALUE_INIT_ACTION + '_SUCCESS';
export const FETCH_CPVALUE_FAIL_ACTION = FETCH_CPVALUE_INIT_ACTION + '_ERROR';

export const ADD_CPVALUE_INIT_ACTION = 'ADD_CPVALUE_INIT_ACTION';
export const ADD_CPVALUE_SUCCESS_ACTION = ADD_CPVALUE_INIT_ACTION + '_SUCCESS';
export const ADD_CPVALUE_FAIL_ACTION = ADD_CPVALUE_INIT_ACTION + '_ERROR';

export function fetchCpvalue() {
  return {
    type: FETCH_CPVALUE_INIT_ACTION,
  };
}
export function AddCpvalue(value) {
  console.log('AddCpvalue AddCpvalue================', value);
  return {
    type: ADD_CPVALUE_INIT_ACTION,
    value: value,
  };
}
